import React from 'react';
import {Divider, Grid, Typography} from '@mui/material';
import './SummaryPane.css';
import {wizardFieldsType} from '../Wizard/Wizard';
import theme from '../../theme/Theme';

const classes = {
  root: {
    flexGrow: 1,
  },
  title: {
    ...theme.typography.button,
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 'bold',
  },
  value: {
    ...theme.typography.button,
    color: theme.palette.text.primary,
    fontSize: '14px',
  },
};

export function SubmitRow<T extends wizardFieldsType>({
  label,
  title,
  answer,
  onClick,
}: {
  label: string;
  title: string;
  answer: string | boolean;
  onClick: () => void;
}) {
  return (
    <Grid className="answer-wrapper" onClick={onClick} data-test={label} container>
      <Grid item pr={1} paddingBottom={2} paddingTop={2} xs={6}>
        <Typography sx={classes.title}>{title}</Typography>
      </Grid>
      <Grid item className="answer" padding={1} paddingBottom={2} paddingTop={2} xs={6}>
        <Typography sx={classes.value}>{answer.toLocaleString()}</Typography>
      </Grid>
      <Divider flexItem className="divider" />
    </Grid>
  );
}
